import React, { useEffect, useState } from 'react';
import { Box, Button, TextareaAutosize } from '@mui/material';
import styles from './TaxInvoices.module.css';
import { FiEdit } from 'react-icons/fi';
import EditGst from './EditGst';
import EditInvoiceNumber from './EditInvoiceNumber';
import EditInvoiceFooter from './EditInvoiceFooter';

function InvoiceDetails(props: any) {
  const {
    UpdateStudentInvoiceSettings,
    UpdateInvoiceFooter,
    invoiceSettingUpdateSuccess,
    invoiceSettings,
    blurrEffect,
    hasTaxInvoiceAccess,
    selectedCountry,
    invoiceFooter,
    handleCancelInvoiceFooter,
    isEditingInvoiceFooter,
    toggleInvoiceFooter,
    setCreateInvoice,
    isEditingGst,
    setIsEditingGst,
    isEditingInvoiceNumber,
    setIsEditingInvoiceNumber,
  } = props;

  // const [isEditingGst, setIsEditingGst] = useState<boolean>(false);
  // const [isEditingInvoiceNumber, setIsEditingInvoiceNumber] =
  //   useState<boolean>(false);

  const handleCancelEdit = () => {
    setIsEditingGst(false);

    setIsEditingInvoiceNumber(false);
    setCreateInvoice(false);
  };

  React.useEffect(() => {
    if (
      invoiceSettingUpdateSuccess !== true &&
      invoiceSettingUpdateSuccess !== false
    ) {
      setIsEditingGst(false);
      setIsEditingInvoiceNumber(false);
    }
  }, [invoiceSettingUpdateSuccess]);

  console.log('invoiceSettings', invoiceSettings);
  return (
    <Box
      sx={{
        position: 'relative',
      }}
    >
      {/* 			<div
				style={{
					position: 'absolute',
					height: '100%',
					width: ' 100%',
					background: 'rgb(241 241 241 / 78%)',
					display: blurrEffect ? 'block' : 'none',
				}}></div> */}
      {!isEditingGst && !isEditingInvoiceNumber && !isEditingInvoiceFooter && (
        <Box
          sx={{
            padding: ' 24px 20px 20px 20px',
          }}
          className={styles.invoiceDetailsWrapper}
        >
          <div className={styles.invoiceDetailsMainHead}>Invoice Details</div>

          <div
            style={{
              marginTop: '15px',
              borderBottom: '1px solid #E2E2E2',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              paddingBottom: '12px',
            }}
          >
            <div>
              <div className={styles.invoiceDetailsSubHead}>Country</div>
              <div className={styles.value} style={{ marginBottom: '12px' }}>
                {invoiceSettings?.taxInvoiceCountry}
              </div>
              <div className={styles.invoiceDetailsSubHead}>
                Integrated Branch
              </div>
              <div className={styles.value} style={{ marginBottom: '12px' }}>
                {invoiceSettings?.branchData
                  ?.map(
                    (item: any) =>
                      item.branchName.charAt(0).toUpperCase() +
                      item.branchName.slice(1)
                  )
                  .join(', ')}
              </div>
              <div className={styles.invoiceDetailsSubHead}>
                {invoiceSettings?.taxInvoiceCountry === 'India'
                  ? 'GSTIN'
                  : 'VAT'}
              </div>
              <div className={styles.value}>
                {invoiceSettings?.taxInvoiceCountry === 'India'
                  ? invoiceSettings.gstNumber
                  : invoiceSettings?.vatNumber}
              </div>
            </div>
            {hasTaxInvoiceAccess && (
              <Button
                sx={{ textTransform: 'capitalize' }}
                variant="contained"
                disabled={hasTaxInvoiceAccess === false}
                onClick={() => setIsEditingGst(!isEditingGst)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '400',
                  color: '#667085',
                  background: 'transparent',
                }}
              >
                <div style={{ marginTop: '2px' }}>Edit</div>
                <FiEdit size={14} color="#667085" />
              </Button>
            )}
          </div>

          <Box
            sx={{
              display: 'flex',
              paddingTop: '26px',
              paddingBottom: '26px',
              borderBottom: '1px solid #E2E2E2',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
            }}
          >
            <div
              style={{
                display: 'flex',
                gap: '35px',
              }}
            >
              <div>
                <div className={styles.invoiceDetailsSubHead}>Prefix</div>
                <div className={styles.value}>{invoiceSettings?.prefix}</div>
              </div>

              <div>
                <div className={styles.invoiceDetailsSubHead}>Next Number</div>
                <div className={styles.value}>
                  {invoiceSettings?.nextNumber}
                </div>
              </div>
            </div>
            {hasTaxInvoiceAccess && (
              <Button
                sx={{ textTransform: 'capitalize' }}
                variant="contained"
                disabled={hasTaxInvoiceAccess === false}
                onClick={() =>
                  setIsEditingInvoiceNumber(!isEditingInvoiceNumber)
                }
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '400',
                  color: '#667085',
                  background: 'transparent',
                }}
              >
                <div style={{ marginTop: '2px' }}>Edit</div>
                <FiEdit size={14} color="#667085" />
              </Button>
            )}
          </Box>

          <Box sx={{ paddingTop: '20px' }}>
            <div className={styles.invoiceFooter}>
              <div className={styles.invoiceDetailsMainHead}>
                Invoice Footer
              </div>
              <div>
                <Button
                  sx={{ textTransform: 'capitalize' }}
                  variant="contained"
                  disabled={hasTaxInvoiceAccess === false}
                  onClick={toggleInvoiceFooter}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '400',
                    color: '#667085',
                    background: 'transparent',
                  }}
                >
                  <div style={{ marginTop: '2px' }}>Edit</div>
                  <FiEdit size={14} color="#667085" />
                </Button>
              </div>
            </div>
            <TextareaAutosize
              value={invoiceFooter}
              placeholder="Enter text here for the invoice footer..."
              className={styles.customTextarea}
              style={{
                width: '100%',
                resize: 'none',
                cursor: 'default',
                borderRadius: '4px',
                padding: '8px',
                color: '#667085',
                fontFamily: 'poppins',
                border: '1px solid #CFCFCF',
                overflowY: 'auto',
              }}
              minRows={7}
              maxRows={7}
              readOnly
            />
          </Box>
        </Box>
      )}
      {isEditingGst && (
        <EditGst
          onCancelEdit={handleCancelEdit}
          UpdateStudentInvoiceSettings={UpdateStudentInvoiceSettings}
          invoiceSettings={invoiceSettings}
        />
      )}
      {isEditingInvoiceNumber && (
        <EditInvoiceNumber
          onCancelEdit={handleCancelEdit}
          UpdateStudentInvoiceSettings={UpdateStudentInvoiceSettings}
          invoiceSettings={invoiceSettings}
        />
      )}

      {isEditingInvoiceFooter && (
        <EditInvoiceFooter
          onCancelEdit={handleCancelEdit}
          handleCancelInvoiceFooter={handleCancelInvoiceFooter}
          UpdateInvoiceFooter={UpdateInvoiceFooter}
          invoiceSettings={invoiceSettings}
        />
      )}
    </Box>
  );
}

export default InvoiceDetails;
